<template>
    <div style="padding-bottom: 1.5rem;">
        <div class="registraInfor">{{ $t('meg.Registration') }}</div>
        <div style="margin-top: .35rem;margin-left: .6375rem;text-align: left;">
            <ul class="inforLi">
                <li>
                    <span style="margin-right: .3125rem;">{{ $t('meg.user') }}：</span>
                    <span>{{ personInfo.userName }}</span>
                </li>
                <li>
                    <span style="margin-right: .2875rem;">{{ $t('meg.tephone') }}：</span>
                    <span>{{ personInfo.phonenumber }}</span>
                </li>
                <li>
                    <span style="margin-right: .4875rem;">{{ $t('meg.email') }}：</span>
                    <span>{{ personInfo.email }}</span>
                </li>
                <li>
                    <span style="margin-right: .5rem;">{{ $t('meg.username') }}：</span>
                    <span>{{ personInfo.nickName }}</span>
                </li>
                <li>
                    <el-button class="modify" @click="uploadPwd">{{ $t('meg.Changepassword') }}</el-button>
                </li>
                <!-- <li>
                    <el-button class="modify" @click="updatePerson">编辑个人信息</el-button>
                </li> -->
            </ul>
        </div>
        <div class="registraInfor">认证信息</div>
        <div style="margin-top: .35rem;margin-left: .6375rem;text-align: left;" v-if="roleType == '生产商'">
            <ul class="inforLi">
                <li>
                    <span style="margin-right: .3125rem;">{{ $t('meg.Company') }}：</span>
                    <span>{{ inforList.plantName }}</span>
                </li>
                <li>
                    <span style="margin-right: 1.1875rem;">{{ $t('meg.address') }}：</span>
                    <span>{{ inforList.plantAddress }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.Establishment') }}：</span>
                    <span>{{ inforList.establishedTime }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.Number') }}：</span>
                    <span>{{ inforList.personnelTotal }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.cutNum') }}：</span>
                    <span>{{ inforList.tailorNum }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.sewing') }}：</span>
                    <span>{{ inforList.workNum }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.packaging') }}：</span>
                    <span>{{ inforList.packagingNum }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.quality') }}：</span>
                    <span>{{ inforList.qualityNum }}</span>
                </li>

                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.plantArea') }}：</span>
                    <span>{{ inforList.plantArea }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.lines') }}：</span>
                    <span>{{ inforList.productionLineNum }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.category') }}：</span>
                    <span>{{ inforList.processingCategory }}</span>
                </li>
                <li>
                    <span style="margin-right: .975rem;">{{ $t('meg.output') }}：</span>
                    <span>{{ inforList.productionLineNum }}</span>
                </li>
                <li>
                    <span style="margin-right: .9625rem;">{{ $t('meg.value') }}：</span>
                    <span>{{ inforList.annualSales }}</span>
                </li>
                <li>
                    <span style="margin-right: .775rem">{{ $t('meg.orderType') }}：</span>
                    <span>{{ inforList.orderType }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.markets') }}：</span>
                    <span>{{ inforList.principalMarket }}</span>
                </li>
                <li>
                    <span style="margin-right: .5625rem;">{{ $t('meg.contact') }}：</span>
                    <span>{{ inforList.businessContact }}</span>
                </li>
                <li>
                    <span style="margin-right: .5375rem;">{{ $t('meg.contactPhone') }}：</span>
                    <span>{{ inforList.businessContactPhone }}</span>
                </li>
                <li>
                    <span style="margin-right: .5375rem;">{{ $t('meg.ContactEmail') }}：</span>
                    <span>{{ inforList.businessContactEmail }}</span>
                </li>
                <li>
                    <span style="margin-right: .5375rem;">{{ $t('meg.ContactWeChat') }}：</span>
                    <span>{{ inforList.businessContactWx }}</span>
                </li>
                <li>
                    <span style="margin-right:.5375rem;">{{ $t('meg.ContactQQ') }}：</span>
                    <span>{{ inforList.businessContactQq }}</span>
                </li>
                <li>
                    <span style="margin-right: .3rem;">{{ $t('meg.Profile') }}：</span>
                    <span style="line-height: .2625rem;">{{ inforList.plantIntroduce }}</span>
                </li>
                <li style="display: flex;">    
                    <span style="margin-right: .7875rem;">{{ $t('meg.license') }}：</span>
                    <el-image style="width: 2.5rem;object-fit: contain;" :src=inforList.businessLicense :preview-src-list="[inforList.businessLicense]"  :initial-index="0" fit="cover" />
                    <!-- <img :src=clientList.businessLicense alt="" width="100px" height="100px"> -->
                </li>
                <li style="display: flex;">    
                    <span style="margin-right: .7875rem;">{{ $t('meg.facImg') }}：</span>
                    <el-image style="width: 2.5rem;object-fit: contain;" :src=pictureArr[0] :preview-src-list="pictureArr"  :initial-index="0" fit="cover" />
                    <!-- <img :src=clientList.businessLicense alt="" width="100px" height="100px"> -->
                </li>
            </ul>
        </div>
        <div style="margin-top: .35rem;margin-left: .6375rem;text-align: left;" v-if="roleType == '客户'">
            <ul class="inforLi">
                <li>
                    <span style="margin-right: .3125rem;">{{ $t('meg.Company') }}：</span>
                    <span>{{ clientList.companyName }}</span>
                </li>
                <li>
                    <span style="margin-right: 1.1875rem;">{{ $t('meg.address') }}：</span>
                    <span>{{ clientList.companyAddress }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.Establishment') }}：</span>
                    <span>{{ clientList.establishedTime }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.Number') }}：</span>
                    <span>{{ clientList.staffNumber }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.Business') }}：</span>
                    <span>{{ clientList.businessType }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.ProductType') }}：</span>
                    <span>{{ clientList.productType }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.saleType') }}：</span>
                    <span>{{ clientList.marketType }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.distribution') }}：</span>
                    <span>{{ clientList.marketChannel }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.annual') }}：</span>
                    <span>{{ clientList.annualSalesNum }}</span>
                </li>
                <li>
                    <span style="margin-right: .775rem">{{ $t('meg.revenue') }}：</span>
                    <span>{{ clientList.annualSales }}</span>
                </li>
                <li>
                    <span style="margin-right: .3875rem;">{{ $t('meg.processing') }}：</span>
                    <span>{{ clientList.desiredProcessingMode }}</span>
                </li>
                <li>
                    <span style="margin-right: .7875rem;">{{ $t('meg.markets') }}：</span>
                    <span>{{ clientList.principalMarket }}</span>
                </li>
                <li>
                    <span style="margin-right: .5875rem;">{{ $t('meg.contact') }}：</span>
                    <span>{{ clientList.businessContact }}</span>
                </li>
                <li>
                    <span style="margin-right: .1875rem;">{{ $t('meg.Position') }}：</span>
                    <span>{{ clientList.businessContactDuty }}</span>
                </li>
                <li>
                    <span style="margin-right: .2125rem;">{{ $t('meg.information') }}:</span>
                    <span>{{ clientList.businessContactPhone }}</span>
                </li>
                <li>
                    <span style="margin-right: .3rem;">{{ $t('meg.Profile') }}：</span>
                    <span style="line-height: .35rem;">{{ clientList.briefIntroduction }}</span>
                </li>
                <li style="display: flex;">
                    <span style="margin-right: .7875rem;">{{ $t('meg.license') }}：</span>
                    <el-image style="width: 3.75rem; height: 2.5rem;object-fit: contain;" :src=clientList.businessLicense :preview-src-list="[clientList.businessLicense]"  :initial-index="0" fit="cover" />
                    <!-- <img :src=clientList.businessLicense alt="" width="100px" height="100px"> -->
                </li>
            </ul>
        </div>

        <el-dialog v-model="pwdDialog" width="4.9625rem" :before-close="handleClose"> 
            <h1
                style="margin-left: .4875rem; text-align: left; font-size: .3rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">
                {{ $t('meg.Changepassword') }}</h1>
            <div class="pwdForm">
                <el-form label-width="1.7rem" :model="pwdForm" class="demo-form-inline" :rules="formRules" style="margin-right: 1rem;">
                    <el-form-item label="旧密码" required prop="oldPassword">
                        <el-input v-model="pwdForm.oldPassword" clearable />
                    </el-form-item>
                    <el-form-item label="新密码" required prop="newPassword">
                        <el-input v-model="pwdForm.newPassword" clearable />
                    </el-form-item>
                    <el-form-item label="确认密码" required prop="confirmpassword">
                        <el-input v-model="pwdForm.confirmpassword" clearable />
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button class="cancelBtn" @click="pwdDialog = false"> {{ $t('meg.cancel') }}</el-button>
                    <el-button class="uploadBtn" @click="pwdConfirm">
                        {{ $t('meg.confimChange') }}
                    </el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 编辑个人信息弹窗 -->
        <el-dialog v-model="personDialog" width="397" :before-close="handleClose">
            <h1
                style="margin-left: 39px; text-align: left; font-size: 24px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #000000;">
                修改信息</h1>
            <div class="pwdForm">
                <el-form label-width="90px" class="demo-form-inline">
                    <el-form-item label="用户名" required prop="oldPassword">
                        <el-input clearable />
                    </el-form-item>
                    <el-form-item label="手机号" required prop="newPassword">
                        <el-input clearable />
                    </el-form-item>
                    <el-form-item label="邮箱" required prop="confirmpassword">
                        <el-input clearable />
                    </el-form-item>
                    <el-form-item label="姓名" required prop="confirmpassword">
                        <el-input clearable />
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button class="cancelBtn" @click="pwdDialog = false">取消</el-button>
                    <el-button class="uploadBtn" @click="pwdConfirm">
                        确认修改
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { profile, selectClientByUserName, selectPlantByUserName, updatePwd } from "@/api/person.js"
import { onMounted, ref, defineEmits, reactive } from "vue";
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';

const personInfo = ref({})
const router = useRouter()
const inforList = ref({})
const clientList = ref({})
const pictureArr = ref([])
const pwdDialog = ref(false)
const personDialog = ref(false)
const emits = defineEmits(["childEvent"])
const roleType = ref("")
onMounted(() => {
    getpersonList()
})

const formRules = {
    oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
    newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
    confirmpassword: [
        { required: true, message: '请确认密码', trigger: 'blur' },
        {
            validator: (rule, value, callback) => {
                if (value !== pwdForm.newPassword) {
                    callback(new Error('两次输入密码不一致'));
                } else {
                    callback();
                }
            },
            trigger: 'blur',
        },
    ],
};

const pwdForm = reactive({
    oldPassword: "",
    newPassword: "",
    confirmpassword: ""
})

const pwdConfirm = () => {
    // 校验密码是否填写
    if (!pwdForm.oldPassword || !pwdForm.newPassword || !pwdForm.confirmpassword) {
        return ElMessage.error('请填写所有密码信息');
    }
    // 校验密码
    if (pwdForm.newPassword !== pwdForm.confirmpassword) {
        // 提示用户密码不一致
        // 你可以使用 Element UI 提供的 Message 提示组件或其他方式展示提示信息
        // 以下代码示例使用 Element UI Message 提示
        return ElMessage.error('新密码与确认密码不一致');
    }
    let obj = {
        oldPassword: pwdForm.oldPassword,
        newPassword: pwdForm.newPassword
    }
    updatePwd(obj).then(res => {
        if (res.data.code === 200) {
            ElMessage.success('密码修改成功，请重新登录');
            pwdDialog.value = false; // Close the dialog
            localStorage.removeItem("access_token")
            router.push("/index")
        }
    })

}

const uploadPwd = () => {
    pwdDialog.value = true
}

const updatePerson = () => {
    personDialog.value = true
}

const getpersonList = () => {
    profile().then(res => {
        personInfo.value = res.data.data
        roleType.value = res.data.roleGroup
        if (roleType.value == "客户") {
            selectClient()
        } else {
            selectPlant()
        }
    })
}

const selectClient = () => {
    selectClientByUserName().then(res => {
        clientList.value = res.data.data
        const roleType = localStorage.getItem("roleType");
        if (roleType == 1) {
            emits('childEvent', { clientList: clientList.value, roleType });
        }
    })
}

const selectPlant = () => {
    selectPlantByUserName().then(res => {
        inforList.value = res.data.data
        if(!inforList.value.pictures) {
            pictureArr.value = []
        } else 
        inforList.value.pictures.forEach(item => {
            pictureArr.value.push(item.url)
        })
        const roleType = localStorage.getItem("roleType");
        if (roleType == 2) {
            emits('childEvent', { inforList: inforList.value, roleType });
        }
    })
}
</script>

<style scoped>
.registraInfor {
    height: .6375rem;
    background: #EEEEEE;
    opacity: 1;
    margin: .3625rem .3rem 0 .3875rem;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    line-height: .6375rem;
    text-align: left;
    padding-left: .25rem;
}

.inforLi li {
    font-size: .2rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-top: .2375rem;
}

.modify {
    width: 1.9125rem;
    height: .525rem;
    background: #002FA7;
    opacity: 1;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
}

.pwdForm ::v-deep .el-input {
    height: .475rem;
    background: #FFFFFF;
    border-radius: .05rem .05rem .05rem .05rem;
    opacity: 1;
    border: .0125rem solid #DDDDDD;
}

.pwdForm ::v-deep .el-form {
    display: block;
    /* margin-left: 39px; */
}

.uploadBtn {
    /* width: 1.1625rem; */
    height: .475rem;
    background: #002FA7;
    border-radius: .05rem .05rem .05rem .05rem;
    opacity: 1;
    border: .0125rem solid #DDDDDD;
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}

.cancelBtn {
    width: 1.1625rem;
    height: .475rem;
    border-radius: .05rem .05rem .05rem .05rem;
    opacity: 1;
    border: .0125rem solid #DDDDDD;
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #777777;
}
</style>
